import { Rect } from './Rect';
import { Texture } from './Texture';

export class TextSprite {
  public readonly rect: Rect;
  // Game-unit rect for destination quad. Equals rect when canvas pixels === game units (DPR=1).
  public readonly logicalRect: Rect;
  private _texture: Texture;

  constructor(texture: Texture, rect: Rect, logicalRect?: Rect) {
    this._texture = texture;
    this.rect = rect;
    this.logicalRect = logicalRect ?? rect;
  }

  get texture(): Texture {
    return this._texture;
  }
}
